import { c as _c } from "react/compiler-runtime";
import { GetPlaceSchema, z } from '@repo/sdk/zod';
import { Button } from '@repo/ui/components';
import { ChevronLeft, Circle, MapPin } from '@repo/ui/icons';
import { cn } from '@repo/ui/lib';
import Image from 'next/image';
import React from 'react';
const schema = z.object({
  destination: GetPlaceSchema,
  origin: GetPlaceSchema
});
export const WelcomeModalHeader = t0 => {
  const $ = _c(16);
  const {
    drops,
    goBack
  } = t0;
  const t1 = drops && "shadow-lg";
  let t2;
  if ($[0] !== t1) {
    t2 = cn("mb-6 flex flex-col gap-4 py-3 sm:hidden", t1);
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== goBack) {
    t3 = goBack && <Button className={cn("absolute top-2 left-1 aspect-square")} onClick={goBack} size="icon" variant="ghost"><ChevronLeft className="stroke-primary float-left !size-6" /></Button>;
    $[2] = goBack;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t3) {
    t4 = <div>{t3}</div>;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <Image alt="KCharles Logo" height={30} src="/assets/LogoBlack.svg" width={140} />;
    t6 = <div />;
    $[6] = t5;
    $[7] = t6;
  } else {
    t5 = $[6];
    t6 = $[7];
  }
  let t7;
  if ($[8] !== t4) {
    t7 = <div className="flex justify-between">{t4}{t5}{t6}</div>;
    $[8] = t4;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== drops) {
    t8 = drops && <WelcomeModalRoute drops={drops} />;
    $[10] = drops;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== t2 || $[13] !== t7 || $[14] !== t8) {
    t9 = <div className={t2}>{t7}{t8}</div>;
    $[12] = t2;
    $[13] = t7;
    $[14] = t8;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  return t9;
};
export const WelcomeModalRoute = t0 => {
  const $ = _c(20);
  const {
    drops
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="flex translate-y-0.5 flex-col items-center"><Circle className="h-4 w-4 text-gray-700" strokeWidth={3} /><VerticalDots /></div>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== drops.origin.place_name) {
    t2 = <span className="font-bold">{drops.origin.place_name}</span>;
    $[1] = drops.origin.place_name;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <br />;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== drops.origin.formattedAddress || $[5] !== t2) {
    t4 = <div className="items-between flex w-full gap-3">{t1}<p className="max-w-[280px] flex-1 text-center text-balance">{t2}{t3}{drops.origin.formattedAddress}</p></div>;
    $[4] = drops.origin.formattedAddress;
    $[5] = t2;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <MapPin className="text-brand h-5 w-5 -translate-x-0.5" strokeWidth={2} />;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== drops.destination.place_name) {
    t6 = <span className="font-bold">{drops.destination.place_name}</span>;
    $[8] = drops.destination.place_name;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <br />;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== drops.destination.country) {
    t8 = drops.destination.country?.toUpperCase();
    $[11] = drops.destination.country;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== drops.destination.formattedAddress || $[14] !== t6 || $[15] !== t8) {
    t9 = <div className="flex w-full items-start gap-3">{t5}<p className="max-w-[280px] flex-1 text-center text-balance">{t6}{t7}{drops.destination.formattedAddress}, {t8}</p></div>;
    $[13] = drops.destination.formattedAddress;
    $[14] = t6;
    $[15] = t8;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== t4 || $[18] !== t9) {
    t10 = <div className="mx-auto flex -translate-x-1 flex-col items-center gap-2 text-sm text-gray-700">{t4}{t9}</div>;
    $[17] = t4;
    $[18] = t9;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  return t10;
};
const VerticalDots = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="mt-1 flex translate-y-[1px] flex-col items-center gap-1"><span className="h-1 w-1 rounded-full bg-gray-700" /><span className="h-1 w-1 rounded-full bg-gray-700" /><span className="h-1 w-1 rounded-full bg-gray-700" /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};